import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCodeFrame24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCodeFrame24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19 4.5H5A1.5 1.5 0 0 0 3.5 6v1h17V6A1.5 1.5 0 0 0 19 4.5m1.5 4h-17V18A1.5 1.5 0 0 0 5 19.5h14a1.5 1.5 0 0 0 1.5-1.5zM5 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm4.201 7.97a.75.75 0 0 1 0 1.06l-2.085 2.086L9.2 16.2a.75.75 0 0 1-1.06 1.06l-2.616-2.615-.53-.53.53-.53 2.616-2.616a.75.75 0 0 1 1.06 0m5.598 0a.75.75 0 0 0 0 1.06l2.085 2.086-2.085 2.085a.75.75 0 0 0 1.06 1.06l2.616-2.615.53-.53-.53-.53-2.616-2.616a.75.75 0 0 0-1.06 0m-1.099.838a.75.75 0 1 0-1.4-.537l-1.981 5.16a.75.75 0 1 0 1.4.538z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCodeFrame24);
